import ComponentElement from 'components/component-element';
import ReviewCreate from './review-create';
import Review from './review';
import Photogallery from './photogallery';
import AuthorizationModal from 'components/authorization-modal';
import {error} from 'methods/utils';

function Reviews($element, options = {}) {
    ComponentElement.call(this, $element, options);

    this.$container = this.$element.querySelector('.js-reviewsListContainer');
    this.$create    = this.$element.querySelector('.js-reviewCreate');
    this.$more      = this.$element.querySelector('.js-reviewsListMore');

    this.authorization = new AuthorizationModal();
    this.create = new ReviewCreate(this, this.$create, this.$container);
    this.reviews = this.$container ? this.getScopedReviewsElements(this.$container).map(this.initReview.bind(this)) : [];

    this.$photogallery = document.querySelector('.js-photogallery');
    if (this.$photogallery) {
        this.photogallery = new Photogallery(this.$photogallery);
    }

    if (this.$more) {
        this.$more.addEventListener('click', e => {
            this.fetch().then(r => {
                if (!r.more) {
                    this.$more.remove();
                }

                if (!r.content) {
                    return;
                }

                const $div = document.createElement('div');
                $div.insertAdjacentHTML('afterbegin', r.content);

                this.getScopedReviewsElements($div).forEach($element => {
                    this.append(this.initReview($element));
                });
            });
        });
    }
}

Reviews.prototype = Object.create(ComponentElement.prototype);
Object.defineProperty(Reviews.prototype, 'constructor', {
    value: Reviews,
    enumerable: false,
    writable: true,
});

/**
 * Инициализация отзыва
 * @param  {HTMLElement} $element Элемент отзыва
 * @return {Review}
 */
Reviews.prototype.initReview = function($element) {
    return new Review($element, this);
}

/**
 * Авторизация
 * @return {Promise}
 */
Reviews.prototype.auth = function() {
    return this.authorization.auth('tourist').catch(error);
}

Reviews.prototype.getScopedReviewsElements = function($from) {
    return [...$from.querySelectorAll(':scope > .js-review')];
}

Reviews.prototype.append = function(review) {
    this.reviews.push(review);
    this.$container.appendChild(review.$element);
    review.update();
}

Reviews.prototype.fetch = function() {
    const formData = new FormData();

    this.reviews.forEach(review => {
        formData.append('exclude[]', review.data.id);
    });

    return fetch('ajax_fetch_reviews/', {
        method: 'POST',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
    })
    .then(response => response.json())
    .then(r => {
        if (r.status != 'ok') {
            throw r;
        }

        return r;
    });
}

export default Reviews;
